import { baseApi } from "../baseApi";

/**
 * Admin API endpoints for invitations and user management
 */
const adminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Invitation management
    createInvitation: builder.mutation({
      query: (inviteData) => ({
        url: "/api/invitations",
        method: "POST",
        body: inviteData,
      }),
      invalidatesTags: ["Invitation"],
    }),

    createBulkInvitations: builder.mutation({
      query: (invitations) => ({
        url: "/api/invitations/bulk",
        method: "POST",
        body: { invitations },
      }),
      invalidatesTags: ["Invitation"],
    }),

    getInvitations: builder.query({
      query: ({ status, page, limit, search } = {}) => ({
        url: "/api/invitations",
        method: "GET",
        params: { status, page, limit, search },
      }),
      providesTags: ["Invitation"],
    }),

    getInvitation: builder.query({
      query: (id) => ({
        url: `/api/invitations/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Invitation", id }],
    }),

    resendInvitation: builder.mutation({
      query: (id) => ({
        url: `/api/invitations/${id}/resend`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Invitation", id }],
    }),

    revokeInvitation: builder.mutation({
      query: (id) => ({
        url: `/api/invitations/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Invitation"],
    }),

    deleteInvitation: builder.mutation({
      query: (id) => ({
        url: `/api/invitations/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Invitation"],
    }),
  }),
});

export const useCreateInvitationMutation = adminApi.useCreateInvitationMutation;
export const useCreateBulkInvitationsMutation = adminApi.useCreateBulkInvitationsMutation;
export const useGetInvitationsQuery = adminApi.useGetInvitationsQuery;
export const useGetInvitationQuery = adminApi.useGetInvitationQuery;
export const useResendInvitationMutation = adminApi.useResendInvitationMutation;
export const useRevokeInvitationMutation = adminApi.useRevokeInvitationMutation;
export const useDeleteInvitationMutation = adminApi.useDeleteInvitationMutation;
